import moment from 'moment'
moment.locale('zh-cn', {
    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'YYYY年MM月DD日',
        LLL: 'YYYY年MM月DD日Ah点mm分',
        LLLL: 'YYYY年MM月DD日ddddAh点mm分',
        l: 'YYYY-M-D',
        ll: 'YYYY年M月D日',
        lll: 'YYYY年M月D日 HH:mm',
        llll: 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
            meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        const hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar: {
        sameDay: '[今天]LT',
        nextDay: '[明天]LT',
        nextWeek: '[下]ddddLT',
        lastDay: '[昨天]LT',
        lastWeek: '[上]ddddLT',
        sameElse: 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime: {
        future: '%s内',
        past: '%s前',
        s: '几秒',
        ss: '%d秒',
        m: '1分钟',
        mm: '%d分钟',
        h: '1小时',
        hh: '%d小时',
        d: '1天',
        dd: '%d天',
        M: '1个月',
        MM: '%d个月',
        y: '1年',
        yy: '%d年'
    },
    week: {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
  })
export default function(Vue) {
	Vue.filter('dateCompared_',function(ms){
		let time = moment().diff(moment(ms), "seconds");
		let timeStr = "";
      if (time < 60) {
        timeStr = "1分钟前";
      } else if (time < 3600) {
        timeStr = parseInt(time / 60) + "分钟前";
      } else if (time <3600*24) {
        	timeStr = parseInt(time/3600) + '小时前'
      } else if(time < 31536000){ //一年的
        timeStr = moment(ms).format("MM-DD HH:mm");
      }else{
				timeStr = moment(ms).format("YYYY-MM-DD HH:mm");
			}
      return timeStr;
		
	});
	Vue.filter('dateComparedTime',(date) => {
		let result = moment(date).startOf('minute').fromNow();
		if (result.indexOf('秒') > -1){
			result= '1分钟前'
		}
		if (result.indexOf('天') > -1 || result.indexOf('月') > -1 || result.indexOf('年') > -1 ) {
			result = moment(date).format('MM-DD HH:mm');
		}
		
		// if(result.indexOf('年') > -1 ) {
		// 	result = moment(date).format('MM-DD HH:mm');
		// }
		// if (result.indexOf('天') > -1 || result.indexOf('月') > -1 || result.indexOf('年') > -1) {
		//     result = moment(date).format('YYYY-MM-DD HH:mm');
		// }   
		return result
	});
	Vue.filter('getTimeUTC',function(time){
			
            let result = ''
            if (time) {
                result = time.substring(0,10) + ' ' + time.substring(11,16)
            }
            return result
	})
	Vue.filter('dateFormat1', function(date, format) {
		if(!date) {
	        return;
	    }
		date = date + '';
		if(date.length === 10) {
			date = parseInt(date) * 1000;
		}
		else {
			date = parseInt(date);
		}
		date = new Date(date);
		if(!format) {
			format = 'yyyy-MM-dd';
		}
		var y_n = (new Date()).getFullYear(), y_o = date.getFullYear();
        if(y_n != y_o && format.indexOf('yyyy') !== 0) {
            format = 'yyyy-' + format;
        }
		var map = {
			'M': date.getMonth() + 1, //月份 
	        'd': date.getDate(), //日 
	        'h': date.getHours(), //小时 
	        'm': date.getMinutes(), //分 
	        's': date.getSeconds(), //秒 
	        'q': Math.floor((date.getMonth() + 3) / 3), //季度 
	        'S': date.getMilliseconds() //毫秒 
		};
		format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
			var v = map[t];
	        if(v !== undefined){
	            if(all.length > 1){
	                v = '0' + v;
	                v = v.substr(v.length-2);
	            }
	            return v;
	        }
	        else if(t === 'y'){
	            return (date.getFullYear() + '').substr(4 - all.length);
	        }
	        return all;
		});
		return format;
	});

	Vue.filter('dateFormat2', function(date) {
		if(!date) {
	        return;
	    }
		date = date + '';
		if(date.length === 10) {
			date = parseInt(date) * 1000;
		}
		else {
			date = parseInt(date);
		}
		date = new Date(date);
		var dateTime = '';
	    var minute = 1000 * 60;
	    var hour = minute * 60;
	    var day = hour * 24;
	    var month = day * 30;
	    function pad (num, n) {
	        var len = num.toString().length;
	        while(len < n) {
	            num = '0' + num;
	            len++;
	        }
	        return num;
	    }
	    function getDateDiff(dateTimeStamp) {
	        var now = new Date().getTime();
	        var diffValue = now - dateTimeStamp;
	        var monthC = diffValue/month;
	        var weekC = diffValue/(7*day);
	        var dayC = diffValue/day;
	        var hourC = diffValue/hour;
	        var minC = diffValue/minute;
	        var result = '刚刚';
	        if(dayC >= 1) {
	            result = pad(date.getMonth() + 1,2)+ '-' +pad(date.getDate(),2);
	            var y_n = (new Date()).getFullYear(), y_o = date.getFullYear();
	            if(y_n != y_o) {
	                result = y_o + '-' + result; 
	            }
	        }
	        else if(hourC >= 1) {
	            result = parseInt(hourC) + '小时前';
	        }
	        else if(minC >= 5) {
	            result = parseInt(minC) + '分钟前';
	        }
	        return result;
	    }
	    dateTime = getDateDiff(date);
	    return dateTime;
	});

	Vue.filter('numberFormat', function(num) {
		num = parseInt(num);
		if(num + '' === 'NaN') {
			return 0;
		}
		if(num >= 1000000 && num < 100000000) {
			return parseInt(num / 10000) + '万';
		}
		else if(num >= 100000000) {
			return '过亿';
		}
		else {
			return num;
		}
	});
	Vue.filter('dateNewComment',function(date){
		 date=date+'';
	     if(date==""){
	       date= new Date();
	     }else if(date.length>10){
	        date = new Date(parseInt(date));
	     }else{
	        date = new Date(parseInt(date) * 1000);
	     }
	    function pad(num, n) {
	        var len = num.toString().length;
	        while(len < n) {
	            num = "0" + num;
	            len++;
	        }
	        return num;
		    }
	    var dateTime = "";
	    var minute = 1000 * 60;
	    var hour = minute * 60;
	    var day = hour * 24;
	    var halfamonth = day * 15;
	    var month = day * 30;
	    function getDateDiff2(dateTimeStamp){
	        var now = new Date().getTime();
	        var diffValue = now - dateTimeStamp;
	        var monthC =diffValue/month;
	        var weekC =diffValue/(7*day);
	        var dayC =diffValue/day;
	        var hourC =diffValue/hour;
	        var minC =diffValue/minute;
	       
	        var y_o = date.getFullYear(),y_n = (new Date()).getFullYear();
	        var d_o = date.getDate(),    d_n = (new Date()).getDate();//日
	        var h_o = date.getHours(),   h_n = (new Date()).getHours(); //小时
	        var m_o = date.getMinutes(), m_n = (new Date()).getMinutes(); //分
	        var s_o = date.getSeconds(), s_n = (new Date()).getSeconds();//秒
	        var result="";
	        if(y_o!=y_n){
          		  result=(y_o + '')+"-"+ pad(date.getMonth() + 1,2)+ "-" +pad(d_o,2)+" "+pad(h_o,2)+":"+pad(m_o,2); 
       		}else if (y_n == y_o){
                if(d_n-d_o==1){
                    result="昨天 "+pad(h_o,2)+":"+pad(m_o,2);
                }else if(d_n-d_o>1){
                    result=pad(date.getMonth() + 1,2)+ "-" +pad(date.getDate(),2)+" "+pad(h_o,2)+":"+pad(m_o,2);
                }else {
                    if(minC>30){
                        result=pad(h_o,2)+":"+pad(m_o,2);
                    }else if (minC<=30 && minC>0){
                        if(m_n-m_o==0)
                            result=Math.abs(m_n-m_o+1)+"分钟前";
                        else{
                            result=Math.abs(m_n-m_o)+"分钟前";
                        }
                     }else {
                        result="1分钟前";
                     }
                }
	        }
	        return result;
		    }
    	dateTime = getDateDiff2(date);
    	return dateTime;
	});
	Vue.filter('dateListComment',function(date){
		date=date+'';
	     if(date==""){
	       date= new Date();
	     }else if(date.length>10){
	        date = new Date(parseInt(date));
	     }else{
	        date = new Date(parseInt(date) * 1000);
	     }
	    function pad(num, n) {
	        var len = num.toString().length;
	        while(len < n) {
	            num = "0" + num;
	            len++;
	        }
	        return num;
		    }
	    var dateTime = "";
	    var minute = 1000 * 60;
	    var hour = minute * 60;
	    var day = hour * 24;
	    var halfamonth = day * 15;
	    var month = day * 30;
	    function getDateDiff2(dateTimeStamp){
	        var now = new Date().getTime();
	        var diffValue = now - dateTimeStamp;
	        var monthC =diffValue/month;
	        var weekC =diffValue/(7*day);
	        var dayC =diffValue/day;
	        var hourC =diffValue/hour;
	        var minC =diffValue/minute;
	       
	        var y_o = date.getFullYear(),y_n = (new Date()).getFullYear();
	        var d_o = date.getDate(),    d_n = (new Date()).getDate();//日
	        var h_o = date.getHours(),   h_n = (new Date()).getHours(); //小时
	        var m_o = date.getMinutes(), m_n = (new Date()).getMinutes(); //分
	        var s_o = date.getSeconds(), s_n = (new Date()).getSeconds();//秒
	        var result="";
	        if(y_o!=y_n){
          		  result=(y_o + '')+"-"+ pad(date.getMonth() + 1,2)+ "-" +pad(d_o,2); 
       		}else if (y_n == y_o){
                if(d_n-d_o==1){
                    result="昨天 "+pad(h_o,2)+":"+pad(m_o,2);
                }else if(d_n-d_o>1){
                    result=pad(date.getMonth() + 1,2)+ "-" +pad(date.getDate(),2);
                }else {
                    if(minC>30){
                        result=pad(h_o,2)+":"+pad(m_o,2);
                    }else if (minC<=30 && minC>0){
                        if(m_n-m_o==0)
                            result=Math.abs(m_n-m_o+1)+"分钟前";
                        else{
                            result=Math.abs(m_n-m_o)+"分钟前";
                        }
                     }else {
                        result="1分钟前";
                     }
                }
	        }
	        return result;
		    }
    	dateTime = getDateDiff2(date);
    	return dateTime;
	});
	Vue.filter('dataISO',function(string){
			var regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" +
				"(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?" +
				"(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
			if(string)
			{
				var d = string.match(new RegExp(regexp));
				var offset = 0;
				var date = new Date(d[1], 0, 1);
				var time;
				if (d[3]) {
					date.setMonth(d[3] - 1);
				}
				if (d[5]) {
					date.setDate(d[5]);
				}
				if (d[7]) {
					date.setHours(d[7]);
				}
				if (d[8]) {
					date.setMinutes(d[8]);
				}
				if (d[10]) {
					date.setSeconds(d[10]);
				}
				if (d[12]) {
					date.setMilliseconds(Number("0." + d[12]) * 1000);
				}
				if (d[14]) {
					offset = (Number(d[16]) * 60) + Number(d[17]);
					offset *= ((d[15] == '-') ? 1 : -1);
				}
				offset -= date.getTimezoneOffset();
				time = (Number(date) + (offset * 60 * 1000));
				return bbb(time)
				
				//console.log(Vue.filter.dateListComment(time))
				// console.log(this.setTime(Number(time))+"ddd")
				// return this.setTime(Number(time));
			}
			else
			{
				return;
			}
		
	});
	Vue.filter('dateCompared',(date) => {
		let result = moment(date).startOf('minute').fromNow();
		if (result.indexOf('秒') > -1){
			result= '1分钟前'
		}
		if (result.indexOf('天') > -1 || result.indexOf('月') > -1) {
			result = moment(date).format('MM-DD HH:mm');
		}
		
		if(result.indexOf('年') > -1 ) {
			result = moment(date).format('YYYY-MM-DD HH:mm');
		}
    // if (result.indexOf('天') > -1 || result.indexOf('月') > -1 || result.indexOf('年') > -1) {
    //     result = moment(date).format('YYYY-MM-DD HH:mm');
    // }   
    return result
});
/**
 * 0分钟<T<1分钟  ： 1分钟前
 * 1分钟<=T<1小时  ：xx分钟前
 * 1小时<= T<24小时 几小时前
 * 24小时<=T  且昨天  ：  昨天 HH:mm
 * 今年 ： MM-dd HH:mm
 * 跨年 ： yyyy-MM-dd HH:mm
 * 全局时间刚刚规则：用于新闻 我操作相关的评论，收藏,直播间，网友互动....
 *
 */
	function bbb(date){
		console.log(date)
		date=date+'';
	     if(date==""){
	       date= new Date();
	     }else if(date.length>10){
	        date = new Date(parseInt(date));
	     }else{
	        date = new Date(parseInt(date) * 1000);
	     }
	    function pad(num, n) {
	        var len = num.toString().length;
	        while(len < n) {
	            num = "0" + num;
	            len++;
	        }
	        return num;
		    }
	    var dateTime = "";
	    var minute = 1000 * 60;
	    var hour = minute * 60;
	    var day = hour * 24;
	    var halfamonth = day * 15;
	    var month = day * 30;
	    function getDateDiff2(dateTimeStamp){
	        var now = new Date().getTime();
	        var diffValue = now - dateTimeStamp;
	        var monthC =diffValue/month;
	        var weekC =diffValue/(7*day);
	        var dayC =diffValue/day;
	        var hourC =diffValue/hour;
	        var minC =diffValue/minute;
	       
	        var y_o = date.getFullYear(),y_n = (new Date()).getFullYear();
	        var d_o = date.getDate(),    d_n = (new Date()).getDate();//日
	        var h_o = date.getHours(),   h_n = (new Date()).getHours(); //小时
	        var m_o = date.getMinutes(), m_n = (new Date()).getMinutes(); //分
	        var s_o = date.getSeconds(), s_n = (new Date()).getSeconds();//秒
	        var result="";
	        if(y_o!=y_n){
          		  result=(y_o + '')+"-"+ pad(date.getMonth() + 1,2)+ "-" +pad(d_o,2); 
       		}else if (y_n == y_o){
                if(d_n-d_o==1){
                    result="昨天 "+pad(h_o,2)+":"+pad(m_o,2);
                }else if(d_n-d_o>1){
                    result=pad(date.getMonth() + 1,2)+ "-" +pad(date.getDate(),2);
                }else {
                    if(minC>30){
                        result=pad(h_o,2)+":"+pad(m_o,2);
                    }else if (minC<=30 && minC>0){
                        if(m_n-m_o==0)
                            result=Math.abs(m_n-m_o+1)+"分钟前";
                        else{
                            result=Math.abs(m_n-m_o)+"分钟前";
                        }
                     }else {
                        result="1分钟前";
                     }
                }
	        }
	        return result;
		}
    	dateTime = getDateDiff2(date);
    	return dateTime;
	}
}



// let dateCompared = (date) => {
//     let result = moment(date).startOf('minute').fromNow();
//     if (result.indexOf('天') > -1 || result.indexOf('月') > -1 || result.indexOf('年') > -1) {
//         result = moment(date).format('YYYY-MM-DD HH:mm');
//     }   
//     return result
// }; 


// WEBPACK FOOTER //
// ./src/filters/base.js